type Nullable<T> = T | undefined | null;
export function uniq<T extends K[], K>(data: Nullable<T>): T {
  if (data) {
    return [...new Set(data)] as T;
  }

  return [] as unknown as T;
}
